export default __webpack_public_path__ + "static/media/portfolio-183.c048914b.jpg";